import type { MeshContainerLayout, MeshItemLayout, SingleLayoutData } from '@wix/thunderbolt-becky-types'

type ComponentLayoutRetriever = (item: SingleLayoutData) => number

export const top: ComponentLayoutRetriever = (layoutData) => (layoutData.itemLayout as MeshItemLayout).meshData.y

export const left: ComponentLayoutRetriever = (layoutData) => (layoutData.itemLayout as MeshItemLayout).meshData.x

export const height: ComponentLayoutRetriever = (layoutData) =>
	(layoutData.itemLayout as MeshItemLayout).meshData.height
export const bottom: ComponentLayoutRetriever = (layoutData) => top(layoutData) + height(layoutData)
export const fitToContentHeight = (layoutData: SingleLayoutData) =>
	(layoutData.containerLayout as MeshContainerLayout)?.meshData.contentHeight === 'auto'
export const getContainerHeight = (layoutData: SingleLayoutData): number =>
	(layoutData.containerLayout as MeshContainerLayout)?.meshData.contentHeight as number
